import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { makeStyles } from "@material-ui/core/styles"
import { Grid, IconButton, Tooltip, Typography } from "@material-ui/core"
import { useSelector, useDispatch } from "react-redux"
import AddTagSVG from "../icons/AddTagSVG"
import CreateTag from "./CreateTag"
import { CONTEXT_TYPE, DETAIL_VIEW } from "../../utils"
import TagChip from "./TagChip"
import InfoIconSVG from "../icons/InfoIconSVG"

const useStyles = makeStyles((theme) => ({
	addTagText: {
		textDecoration: "underline",
		color: theme.palette.primary.dark,
		fontStyle: "italic",
	},
}))

function ViewerMultiTag(props) {
	const classes = useStyles()
	const [showApplyTag, setShowApplyTag] = useState(false)
	const [t] = useTranslation("global")
	const { review } = useSelector((state) => state?.review)

	const handleApplyTagClick = (e) => {
		setShowApplyTag(true)
	}

	const getCurrentContext = () => {
		if (review?.id) {
			return {
				name: CONTEXT_TYPE?.REVIEW,
				id: review?.id,
			}
		} else if (props?.retainedFilterJobData?.additional_params?.search_id) {
			return {
				name: CONTEXT_TYPE?.SEARCH,
				id: props?.retainedFilterJobData?.additional_params?.search_id,
			}
		} else {
			return {
				name: CONTEXT_TYPE?.FILE,
				id: 0,
			}
		}
	}

	useEffect(() => {
		setShowApplyTag(false)
	}, [])

	return (
		<Grid container style={{ padding: "12px 16px 25px" }}>
			<Grid item xs={12}>
				{showApplyTag ? (
					<CreateTag
						fileId={props?.fileData?.id}
						setShowApplyTag={setShowApplyTag}
						currentContext={getCurrentContext}
						tagData={props?.fileData?.tags}
					/>
				) : (
					<>
						<IconButton onClick={handleApplyTagClick} size="small">
							<AddTagSVG />
							<Typography className={classes.addTagText} variant="body2" noWrap>
								{t("tag.addTag")}
							</Typography>
						</IconButton>
						<Tooltip title={t("tag.tagInfo")} placement="top">
							<IconButton style={{ padding: 0 }}>
								<InfoIconSVG />
							</IconButton>
						</Tooltip>
					</>
				)}
			</Grid>
			<Grid item xs={12}>
				<TagChip
					fileId={props?.fileData?.id}
					tagData={props?.fileData?.tags}
					getCurrContext={getCurrentContext}
					view={DETAIL_VIEW}
				/>
			</Grid>
		</Grid>
	)
}

export default ViewerMultiTag
